(function scrollApple() {
    var image = document.querySelector('.zoom-image');
    if (image) {
        var getScaleAmount_1 = function (number, inMin, inMax, outMin, outMax) {
            return (number - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
        };
        var scaleDiv_1 = function () {
            var scrollPos = scrollY;
            var scrollDistance = window.innerHeight;
            var percentage = scrollPos / scrollDistance;
            // const scaleAmount = getScaleAmount(percentage, 0, 1, 1, 0.6)
            var scaleAmount = getScaleAmount_1(percentage, 1, 1.6, 0.7, 1);
            //@ts-ignore
            //image.style.backgroundSize = scaleAmount * 100 + '%'
            image.style.transform = "scale(" + scaleAmount + ")";
        };
        window.addEventListener('scroll', function () {
            scaleDiv_1();
        });
    }
})();
